import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SideBar from "../common/sideBar";
import {
  postServerDataWithPath,
  getServerDataWithTypes,
} from "../../../action/common_action";
import { axiosInstnace as Axios, axiosInstnace } from "../../../util/util";
import { endPoints } from "../../../config";
import NoData from "../common/NoData";
import Pagination from "../common/Pagination";
import Drag from "./dragNdDrop";
import moment from "moment";
import useModel from "../common/useModel";
import DatePicker from "react-datepicker";
import { addDays, addMonths } from "date-fns";
import ReactAudioPlayer from "react-audio-player";
import { ToastContainer, toast } from "react-toastify";
import ExcelPopup from "./ExcelPopup";
import { history } from "../../../history/history";
import UploadContract from "../manageCampaign/UploadContract";
import AudioRequestDetails from "./AudioRequestDetails";
import AudioBriefPopup from "./AudioBriefPopup";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import MultipleaudioList from "../../common/audiolist";
import { CommonModelImpl } from "../common/CommonModel";
import ViewStationsModal from "./ViewStationsModal";

const audioRequestManagement = (props) => {
  const [audiolist, handleAudioList] = useState([]);

  const [audioStatustype, handleaudioStatustype] = useState(undefined);
  const [showExcelPopup, setShowHideExcelPopup] = useState(false);
  const [showUploadAudio, handleShowUploadAudio] = useState(false);
  const [showMultipleAudio, handleshowMultipleAudio] = useState(false);
  const [multipleAudios, handleMultipleAudios] = useState([]);
  const [showAudioBrief, handleShowAudioBrief] = useState(false);
  // const [showHideUploadAudio, handleShowHideUploadAudio]= useState(false);
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const campaignName = useRef(undefined);
  const campaignId = useRef(undefined);
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
  const [campaignDetails, handleCampaignDetails] = useState({});
  const [showAssignConfirm, handleshowAssignConfirm] = useState(false);
  const [showUnAssignConfirm, handleshowUnAssignConfirm] = useState(false);
  const [currentCampaign, handleCurrentCampaign] = useState("");
  const [showstationlist, handleshowstationlist] = useState(false);
  const [currentStations, handleCurrentStations] = useState([]);


  useEffect(() => {
    getAudiolist(0);
  }, []);

  const showHideExcelPopup = () => {
    setShowHideExcelPopup(!showExcelPopup);
  };

  const hideshowstations = (e) => {
    handleshowstationlist(!showstationlist);
  };

  const showHideUploadAudio = (campaign) => {
    handleCampaignDetails(campaign);
    handleShowUploadAudio(!showUploadAudio);
  };
  const hideMultipleAudio = () => {
    handleshowMultipleAudio(false);
  };
  const showHideUnAssignConfirm = () => {
    handleshowUnAssignConfirm(!showUnAssignConfirm);
  };
  const showHideAssignConfirm = () => {
    handleshowAssignConfirm(!showAssignConfirm);
  };
  const showHideAudioBrief = (campaign) => {
    handleCampaignDetails(campaign);
    handleShowAudioBrief(!showAudioBrief);
  };
  const setAssignee = async () => {
    let data = {
      id: currentCampaign,
      email: adminInfo.email,
    };
    let status = await axiosInstnace.post(endPoints.assignAudioCreation, data);
    showHideAssignConfirm();
    if (status.data.code === 400) {
      alert(status.data.message);
    }else{
      callCurrentPage()
    }
  };
  const RemoveAssignee = async()=>{
    let data = {
      id: currentCampaign,
      email: "",
    };
    let status = await axiosInstnace.post(endPoints.assignAudioCreation, data);
    showHideAssignConfirm();
    if (status.data.code === 400) {
      alert(status.data.message);
    }else{
      window.location.reload(true)
    }
  }
  
  const callCurrentPage = ()=>{
    getAudiolist(skip)
  }

  //Get getAudiolist
  const getAudiolist = async (skip) => {
    console.log("Get audio list");
    handleSkip(skip);
    try {
      let data = await Axios.get(endPoints.getAudioRequests, {
        //  const data = await Axios.get(endPoints.getAudiolist,{
        params: {
          skip,
          audioStatus: audioStatustype,
          fileName: campaignName.current.value,
          _id: campaignId.current.value,
          startDate,
          endDate,
          cluster: adminInfo.role === "admin" ? undefined : adminInfo.cluster,
        },
      });
      if (!data || !data.data || !data.data.data) {
        data = { data: { data: { data: [] } } };
      }
      const result = data.data.data.data;
      if (result) {
        handleCount(data.data.data.count);
        handleAudioList(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const openPopup = (event, rejetcremarkss) => {
    console.log(event.target.value);
    console.log(rejetcremarkss.status);
    if (
      rejetcremarkss &&
      rejetcremarkss.status &&
      rejetcremarkss.status != "New" &&
      event.target.value === "New"
    ) {
      console.log("Error");
      toast.warn("Status cannot be set to New", {
        position: toast.POSITION.TOP_CENTER,

        hideProgressBar: false,
        toastId: "1",
      });
    } else {
      rejetcremarkss.status = event.target.value;
      rejetcremarkss.showAddRemarks = true;
      rejetcremarkss.showListRemarks = true;
      handlerejetcremarks(rejetcremarkss);
      toggle();
    }
  };

  const openRemarksPopup = (rejetcremarkss) => {
    console.log(rejetcremarkss);
    rejetcremarkss.showAddRemarks = false;
    rejetcremarkss.showListRemarks = true;
    rejetcremarkss.remarks = rejetcremarkss.remarks.reverse();
    handlerejetcremarks(rejetcremarkss);
    toggle();
  };


  //Redirect to route bassed on path
  const goToRoute = (name, data, path) => {
    history.push(path, {
      [name]: data,
    });
  };

  const clearSearch = () => {
    window.location.reload(true);
  };

  const getUploadedFile = (event) => {
    this.setState({
      uploadAudio: event.target,
    });
  };

  const callSearch = (e) => {
    e.preventDefault();
    getAudiolist(0);
  };

  //Return the t
  return (
    <div>
      <div className="dashboardContainer">
        <HeaderAdminpanel />
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>
          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Audio Request Management |{" "}
                <span className="breadcrumb-active advertiser-breadcrumb">
                  {" "}
                  Audio Request List{" "}
                </span>{" "}
              </div>{" "}
            </div>{" "}
            <form id="search-campaign-form" action="">
              <table cellPadding="10" cellSpacing="10" className="searchTable">
                <tbody>
                  <tr>
                    <td>
                      <div className="startDate">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          dateFormatCalendar={"MMM yyyy"}
                          placeholderText=" Start Date"
                          maxDate={endDate}
                          isClearable
                        />
                      </div>{" "}
                    </td>{" "}
                    <td>
                      <div className="endDate">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          dateFormatCalendar={"MMM yyyy"}
                          minDate={startDate}
                          placeholderText=" End date"
                          isClearable
                        />
                      </div>{" "}
                    </td>
                    <td>
                      <div className="drop">
                        <select
                          className="packageType drop-down-icon"
                          onChange={(event) =>
                            handleaudioStatustype(event.target.value)
                          }
                        >
                          <option value=""> Choose Audio Status </option>{" "}
                          <option value="Requested"> Requested </option>{" "}
                          <option value="Audio Rejected">
                            {" "}
                            Audio Rejected{" "}
                          </option>{" "}
                        </select>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          ref={campaignName}
                          placeholder="Campaign Name"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>{" "}
                    <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          ref={campaignId}
                          placeholder="Campaign Id"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>{" "}
                  </tr>{" "}
                  <tr>
                    <td>
                      <span className="print_btn">
                        <button onClick={callSearch}> Search </button>{" "}
                      </span>{" "}
                    </td>{" "}
                    <td>
                      <span className="print_btn mrgLft10px">
                        <button onClick={clearSearch}> Clear </button>{" "}
                      </span>{" "}
                    </td>{" "}
                  </tr>{" "}
                </tbody>{" "}
              </table>{" "}
            </form>
            <div
              className={
                audiolist.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th> Campaign Id </th> <th> Campaign Name </th>{" "}
                    <th> Start Date </th> <th> Requested Date </th>{" "}
                    <th> Requested By </th> <th> Sales User Id </th>{" "}
                    <th> Station </th> <th>Assignee</th> <th> Audio Brief </th>{" "}
                    <th> Audio Length </th> <th> Audio Status </th>{" "}
                    <th> Remarks </th> <th> Play Audio </th>{" "}
                    {/* <th>Brief</th>  */} <th> Approved / Rejected By </th>{" "}
                    <th> Upload Audio </th>{" "}
                  </tr>{" "}
                </thead>{" "}
                <tbody>
                  {" "}
                  {audiolist.map((a, i) => (
                    <tr key={i}>
                      <td> {a._id} </td> <td> {a.name} </td>{" "}
                      <td> {moment(a.startDate).format("DD/MM/YYYY")} </td>{" "}
                      <td> {moment(a.createdAt).format("DD/MM/YYYY")} </td>{" "}
                      <td>
                        <p> {a.userEmail} </p>{" "}
                        {a.userDetails && a.userDetails.length > 0 && (
                          <p> {a.userDetails[0].name} </p>
                        )}{" "}
                      </td>{" "}
                      <td> {a.sallerId} </td> <td> {a.station.includes(",") ? (
                              <a
                                onClick={(e) => {
                                  debugger;
                                  handleshowstationlist(true);
                                  handleCurrentStations(a.station.split(","));
                                }}
                              >
                                Multiple ({a.station.split(",").length})
                              </a>
                            ) : (
                              a.station
                            )} </td>{" "}
                      <td>
                       
                        {a.audioCreation && a.audioCreation.email}
                        {a.audioCreation && a.audioCreation.email && a.audioCreation.email === adminInfo.email && (
                          <a
                            style={{ fontSize: "12px", color: "blue" }}
                            onClick={(e) => {
                              handleCurrentCampaign(a._id);
                              showHideUnAssignConfirm();
                            }}
                          >
                            {" "}Unassign
                          </a>
                        )}
                        {(!a.audioCreation || !a.audioCreation.email) && (
                          <a
                            style={{ fontSize: "12px", color: "blue" }}
                            onClick={(e) => {
                              handleCurrentCampaign(a._id);
                              showHideAssignConfirm();
                            }}
                          >
                            Assign to me
                          </a>
                        )}
                      </td>
                      <td className="txt-cntr">
                        <a>
                          <span className="tooltip-reject view-tooltip">
                            {" "}
                            {/*<img src="/assets/images/upload.png" className="upload-png reject-png" onClick={() => history.push('/admin/audioadminmanagment/UploadAudiolist',{a})}>*/}{" "}
                            <img
                              src="/assets/images/eye.png"
                              className="uploadaudiofile"
                              onClick={() => showHideAudioBrief(a)}
                            ></img>{" "}
                            <span> View </span>{" "}
                          </span>{" "}
                        </a>{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        {a.audioLength}
                        Secs{" "}
                      </td>{" "}
                      <td>
                        <span
                          className={
                            a.audioStatus == "Requested"
                              ? "new"
                              : a.status === "Approved"
                              ? " audio_approved"
                              : " ro_approved"
                          }
                        >
                          {" "}
                          {a.audioStatus}{" "}
                        </span>{" "}
                      </td>{" "}
                      <td>
                        <span> {a.reason} </span>{" "}
                      </td>{" "}
                      {a.audioUrl && (
                        <td>
                          <ReactAudioPlayer src={a.audioUrl} controls />
                        </td>
                      )}
                      {!a.audioUrl && a.audioUrls && a.audioUrls.length > 0 && (
                        <td
                          className="txt-cntr"
                          style={{ cursor: "pointer", textAlign: "center" }}
                          onClick={(e) => {
                            handleshowMultipleAudio(true);
                            handleMultipleAudios(a.audioUrls);
                          }}
                        >
                          {a.audioUrls.length}
                        </td>
                      )}
                      {!a.audioUrl &&
                        a.audioUrls &&
                        a.audioUrls.length == 0 && (
                          <td className="txt-cntr">NA </td>
                        )}
                      <td> {a.approvedOrRejectedBy} </td>
                      {(adminInfo.role == "audioAdmin" ||
                        adminInfo.role == "admin") && a.audioCreation && a.audioCreation.email && a.audioCreation.email === adminInfo.email && (
                        <td className="txt-cntr">
                          <a>
                            <span className="tooltip-reject view-tooltip">
                              {" "}
                              {/*<img src="/assets/images/upload.png" className="upload-png reject-png" onClick={() => history.push('/admin/audioadminmanagment/UploadAudiolist',{a})}>*/}{" "}
                              <img
                                src="/assets/images/upload_audio.png"
                                className="uploadaudiofile"
                                onClick={() => showHideUploadAudio(a)}
                              ></img>{" "}
                              <span> Upload </span>{" "}
                            </span>{" "}
                          </a>{" "}
                        </td>
                      )}{" "}
                    </tr>
                  ))}{" "}
                </tbody>{" "}
              </table>{" "}
              <div className="paginationTable" />{" "}
              {(skip > 0 || count >= 10) && (
                <Pagination getAllData={getAudiolist} totalRecords={count} />
              )}{" "}
            </div>{" "}
            {audiolist.length === 0 ? <NoData /> : null}{" "}
          </section>{" "}
        </div>{" "}
      </div>{" "}
      {showExcelPopup && <ExcelPopup hideExcelPopup={showHideExcelPopup} />}
      {showUploadAudio && (
        <AudioRequestDetails
          hideUploadAudio={showHideUploadAudio}
          campaignDetails={campaignDetails}
          callCurrentPage={callCurrentPage}
        />
      )}{" "}
      {showAudioBrief && (
        <AudioBriefPopup
          hideAudioBrief={showHideAudioBrief}
          campaignDetails={campaignDetails}
          type="view"
        />
      )}
      {showMultipleAudio && (
        <MultipleaudioList
          isNewShowing={showMultipleAudio}
          hide={hideMultipleAudio}
          audios={multipleAudios}
        />
      )}
      {showstationlist && (
                <ViewStationsModal
                  stations={currentStations}
                  closeAction={hideshowstations}
                />
              )}
      {showAssignConfirm && (
        <CommonModelImpl
          headerMsg={"Confirm Assign"}
          msg={"Are you sure you want to assign yourself for audio creation"}
          okButtonShow={true}
          okButtonText={"Yes"}
          okAction={setAssignee}
          cancelButtonShow={true}
          cancelButtonText={"No"}
          cancelAction={showHideAssignConfirm}
          callCurrentPage={callCurrentPage}
        />
      )}
       {showUnAssignConfirm && (
        <CommonModelImpl
          headerMsg={"Confirm Un-Assign"}
          msg={"Are you sure you want to unassign yourself for audio creation"}
          okButtonShow={true}
          okButtonText={"Yes"}
          okAction={RemoveAssignee}
          cancelButtonShow={true}
          cancelButtonText={"No"}
          cancelAction={showHideUnAssignConfirm}
        />
      )}
    </div>
  );
};
export default connect(null, {})(audioRequestManagement);



// WEBPACK FOOTER //
// ./web/components/admin/audioadminmanagment/audioRequestManagement.js